import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import CompanyProfileForm from '../components/company/CompanyProfileForm';
import NDASetup from '../components/company/NDASetup';

const TABS = [
  { key: 'profile', label: 'Company Profile' },
  { key: 'nda', label: 'NDA Management' },
];

export default function CompanySettings({ onNavigate }) {
  const { isOrgAdmin, org } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-heading text-3xl text-vault-navy">
          {org?.company_name || 'Company Profile'}
        </h1>
        <p className="text-sm text-gray-400 mt-1">
          {isOrgAdmin
            ? 'Manage your company details, logo, and NDA settings.'
            : 'View your company details. Contact an admin to make changes.'}
        </p>
      </div>

      {!isOrgAdmin && (
        <div className="mb-5 px-4 py-3 rounded-xl bg-amber-50 border border-amber-200 text-sm text-amber-700">
          Company profile and NDA settings can only be edited by organization admins.
        </div>
      )}

      {/* Tabs */}
      <div className="flex gap-1 mb-6 bg-gray-100 rounded-btn p-1 w-fit">
        {TABS.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`py-2 px-4 rounded-[10px] text-sm font-semibold transition-all ${
              activeTab === tab.key
                ? 'bg-white text-vault-navy shadow-btn'
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      {activeTab === 'profile' && (
        <div>
          <CompanyProfileForm />
          {onNavigate && (
            <div className="mt-5 glass p-5 max-w-2xl">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-semibold text-vault-navy">Your Matching Wish List</h3>
                  <p className="text-xs text-gray-400 mt-0.5">Each team member manages their own wish list for personalized matching.</p>
                </div>
                <button
                  onClick={() => onNavigate('wishlist')}
                  className="text-sm font-semibold text-vault-gold hover:underline"
                >
                  Manage My Wish List →
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {activeTab === 'nda' && (
        <div>
          {isOrgAdmin ? (
            <NDASetup />
          ) : (
            <div className="glass p-7 max-w-2xl">
              <h2 className="font-heading text-xl text-vault-navy mb-3">NDA Settings</h2>
              <p className="text-sm text-gray-400 mb-4">Your organization's NDA is managed by the admin.</p>
              {org?.nda_document_url && (
                <a href={org.nda_document_url} target="_blank" rel="noreferrer" className="text-sm text-vault-gold font-semibold hover:underline">
                  View Current NDA Document →
                </a>
              )}
              {org?.nda_link && !org?.nda_document_url && (
                <a href={org.nda_link} target="_blank" rel="noreferrer" className="text-sm text-vault-gold font-semibold hover:underline">
                  View NDA Link →
                </a>
              )}
              {!org?.nda_document_url && !org?.nda_link && (
                <p className="text-sm text-gray-300">No NDA has been configured yet.</p>
              )}
              <div className="mt-3 text-xs text-gray-400">
                Countersign required: {org?.countersign_required ? 'Yes' : 'No'} · Version {org?.nda_version || 1}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
